import apiClient from '@/plugins/apiClient'
let basePath = "/cms/assets";
import qs from 'qs';

export default {
     namespaced: true,
     state:{
          list: [],
          single: null,
          errors: {},
          message: null,
          presignedUrl: null,
          meta: {
               current_page: 1,
               total: 0,
               per_page: 12
          },
          filters: {
               wheres : []
          }
     },
     getters:{
          list: state => state.list,
          single: state => state.single,
          message: state => state.message,
          errors: state => state.errors,
          meta: state => state.meta,
          filters: state => state.filters,
          presignedUrl: state => state.presignedUrl
     },
     mutations:{
          error(state, err) {
               console.log('mutation error',err);
               state.errors = err.response.data
          },
          setMeta(state, resp){
               console.log('mutation setMeta',resp.meta);
               state.meta = resp.meta
          },
          setList(state, resp) {
               console.log('mutation setList',resp);
               state.list = resp.data
               console.log('mutation setSingle',resp.data[0]);
               state.single = resp.data[0]
               state.exportfile = null;
               state.errors = {};
               state.message = null;
          },
          setSingle(state, resp){
               console.log('mutation setSingle',resp.data);
               state.single = resp.data
               state.errors = {};
               state.message = null;
          },
          setFilters(state, resp){
               console.log('mutation setFilters',resp.filters);
               state.filters = resp.filters
          },
          setPresignedUrl(state, resp){
               console.log('mutation setPresignedUrl',resp);
               state.presignedUrl = resp
               state.errors = {};
               state.message = null;
          },
     },
     actions:{
          setAsSingle({state}, data){
               state.single = data;
          },
          setMeta({commit}, data){
               console.log('action setMeta',data);
               commit('setMeta',{meta:data});
          },
          setFilters({commit}, data){
               console.log('action setFilters',data);
               commit('setFilters',{filters:data});
          },
          clearPresignedUrl({commit}){
               commit('setPresignedUrl',null);
          },
          getList({commit, state}, data){
               return new Promise((resolve, reject) => {
                    console.log('GET LIST:'+data)
                    console.log('GET LIST filters:', state.filters)
                    var params =  qs.stringify(state.filters, { arrayFormat: 'indices' })
                    apiClient.get(basePath+'?page='+state.meta.current_page+'&'+params).then(resp => {
                         commit('setList', resp.data);
                         commit('setMeta', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('GET LIST', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          getSingle({commit}, item){
               return new Promise((resolve, reject) => {
                    console.log('GET SINGLE:'+item)
                    apiClient.get(basePath+'/'+item.id).then(resp => {
                         commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         console.log('GET LIST', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          upload({commit},formData){
               return new Promise((resolve, reject) => {
                    console.log('UPLOAD ASSET: ', formData)
                    apiClient.upload(basePath+"/upload", formData).then(resp => {
                         resolve(resp);
                         commit('setSingle', resp.data);
                     })
                     .catch(err => {
                         console.log('ADMIN UPLOAD ASSET ERRROR', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          updateSingle({commit},asset){
               return new Promise((resolve, reject) => {
                    console.log('UPDATE ASSET: ', asset)
                    apiClient.patch(basePath+"/"+asset.id+"/update", asset).then(resp => {
                         resolve(resp);
                         console.log('setSingle',resp.data)
                         commit('setSingle', resp.data);
                     })
                     .catch(err => {
                         console.log('ADMIN UPDATE ASSET ERRROR', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          deleteSingle({commit},asset){
               return new Promise((resolve, reject) => {
                    console.log('DELETE ASSET: ', asset)
                    apiClient.delete(basePath+"/"+asset.id+"/delete").then(resp => {
                         resolve(resp);
                         console.log('setSingle',resp.data)
                         commit('setSingle', resp.data);
                     })
                     .catch(err => {
                         console.log('ADMIN UPDATE ASSET ERRROR', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          getPresignedUrl({commit},asset){
               return new Promise((resolve, reject) => {
                    console.log('GET PRESIGNED URL: ', asset)
                    apiClient.post(basePath+"/presigned-url", asset).then(resp => {
                         resolve(resp);
                         console.log('setPresignedUrl',resp.data)
                         commit('setPresignedUrl', resp.data);
                     })
                     .catch(err => {
                         console.log('ADMIN UPDATE ASSET ERRROR', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          saveAssetUrl({commit},asset){
               return new Promise((resolve, reject) => {
                    console.log('Save Asser PRESIGNED URL: ', asset)
                    apiClient.post(basePath+"/save-url", asset).then(resp => {
                         resolve(resp);
                         console.log('saveAssetUrl',resp.data)
                          commit('setSingle', resp.data);
                     })
                     .catch(err => {
                         console.log('ADMIN PRESIGNED URL ASSET ERRROR', err)
                         commit('error', err);
                         reject(err);
                     });
               })
          }
     }
}